// src/components/common/SectionLoader.js
import React from 'react';

function SectionLoader() {
  return (
    <div className="animate-pulse space-y-6 py-6">
      {/* Title */}
      <div className="h-6 bg-gray-200 rounded w-1/3"></div>

      {/* Card blocks */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {[1, 2, 3, 4].map((item) => (
          <div
            key={item}
            className="p-6 bg-white rounded-xl shadow-sm border border-gray-100 space-y-4"
          >
            <div className="h-4 bg-gray-200 rounded w-3/4"></div>
            <div className="h-4 bg-gray-200 rounded w-1/2"></div>
            <div className="h-4 bg-gray-200 rounded w-full"></div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SectionLoader;
